import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, Typography, Divider, Table, TableBody, TableRow, TableCell, Chip } from '@mui/material';
import dayjs from 'dayjs';
import UserDetailsPayments from '../user-details/UserDetailsPayments';

const TeacherModalEnrollmentDetail = ({ open, onClose, enrollment }) => {
  if (!enrollment) return null;
  const user = enrollment.user || enrollment.userId || {};

  // console.log(enrollment);
  // console.log(user);
  
  return (
    <Dialog open={open} onClose={(e, reason) => {
      if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
      onClose();
    }} maxWidth="sm" fullWidth disableEscapeKeyDown>
      <DialogTitle>Dettaglio Iscrizione</DialogTitle>
      <DialogContent dividers sx={{ p: 3 }}>
        <Box mb={2}>
          <Typography variant="h6" gutterBottom>
            {user.name || '-'} {user.surname || '-'}
          </Typography>
          <Typography variant="subtitle1" color="text.secondary" gutterBottom>
            {user.email || '-'}
          </Typography>
        </Box>
        <Divider sx={{ mb: 2 }} />
        
        {/* Riepilogo Stato Pagamenti */}
        <Box sx={{ mb: 2, p: 2, bgcolor: 'grey.50', borderRadius: 1, border: 1, borderColor: 'grey.200' }}>
          <Typography variant="subtitle2" fontWeight={600} gutterBottom>
            Riepilogo Stato Pagamenti
          </Typography>
          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Chip 
                label={`Pagate: ${enrollment.paymentStatusInfo.paymentsMade ?? 0}`} 
                color="success" 
                size="small" 
              />
            </Box>
            {/* <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Chip 
                label={`Dovute: ${enrollment.paymentStatusInfo.paymentsDue ?? 0}`} 
                color="warning" 
                size="small" 
              />
            </Box> */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Chip 
                label={`In ritardo: ${enrollment.paymentStatusInfo.paymentsLate ?? 0}`} 
                color="error" 
                size="small" 
              />
            </Box>
          </Box>
        </Box>
        
        <Table size="small">
          <TableBody>
            <TableRow>
              <TableCell>Metodo Pagamento</TableCell>
              <TableCell>{enrollment.paymentMethod || '-'}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Stato Pagamento</TableCell>
              <TableCell>
                <Chip
                  label={enrollment.paymentStatusInfo.isEnrollmentPaid ? 'Pagato' : 'Da Pagare'}
                  color={enrollment.paymentStatusInfo.isEnrollmentPaid ? 'success' : 'warning'}
                  size="small"
                  sx={{ fontWeight: 600 }}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Importo</TableCell>
              <TableCell><Typography fontWeight={600}>€{enrollment.amount || '-'}</Typography></TableCell>
            </TableRow>
            {/* <TableRow>
              <TableCell>Data Iscrizione</TableCell>
              <TableCell>{enrollment.createdAt ? dayjs(enrollment.createdAt).locale('it').format('DD-MMM-YY') : '-'}</TableCell>
            </TableRow> */}
            {enrollment.startDate && (
              <TableRow>
                <TableCell>Iscritto a partire da</TableCell>
                <TableCell>{dayjs(enrollment.startDate).locale('it').format('MMMM YY')}</TableCell>
              </TableRow>
            )}
            <TableRow>
              <TableCell>Prossima Scadenza Pagamento</TableCell>
              <TableCell>{enrollment.paymentStatusInfo.nextPaymentDate ? dayjs(enrollment.paymentStatusInfo.nextPaymentDate).locale('it').format('DD MMM YY') : '-'}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Rate</TableCell>
              <TableCell>{enrollment.paymentStatusInfo.paymentsMade ?? '-'}/{enrollment.totalPayments ?? '-'}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
        <UserDetailsPayments userId={enrollment.userId} enrollmentId={enrollment._id} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Chiudi</Button>
      </DialogActions>
    </Dialog>
  );
};

export default TeacherModalEnrollmentDetail; 